/* Corporate prototype behaviour with Shopify native contact transport.
   Input -> confirmation -> native POST. Only Liquid's successful response shows completion. */
(function () {
  'use strict';
  if (document.documentElement.dataset.corpReady) return;
  document.documentElement.dataset.corpReady = 'true';
  document.documentElement.classList.add('js');
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var STORAGE_NAME = 'chapon-corp-inquiry-v1';
  var TYPES = ['wholesale', 'gift', 'oem', 'bridal', 'material', 'other'];
  var LANDING_STORAGE_NAME = 'chapon-corp-landing-v1';

  /* ---------- first corporate landing in this tab (allowlisted attribution only) ---------- */
  function attributionText(value) { return String(value).replace(/[\s\u0000-\u001f\u007f]+/g, ' ').trim().slice(0, 200); }
  var landing = { parameters: [], path: attributionText(location.pathname) };
  new URLSearchParams(location.search).forEach(function (value, key) {
    if (key === 'ref' || key.indexOf('utm_') === 0) landing.parameters.push([attributionText(key), attributionText(value)]);
  });
  try {
    var firstLanding = sessionStorage.getItem(LANDING_STORAGE_NAME);
    if (firstLanding === null) sessionStorage.setItem(LANDING_STORAGE_NAME, JSON.stringify(landing));
    else {
      var savedLanding = JSON.parse(firstLanding);
      if (savedLanding && Array.isArray(savedLanding.parameters) && typeof savedLanding.path === 'string') landing = savedLanding;
    }
  } catch (err) { /* Attribution is optional; sending does not depend on storage. */ }
  var landingPath = 'landing=' + attributionText(landing.path);
  var landingTags = landing.parameters.map(function (entry) { return attributionText(entry[0]) + '=' + attributionText(entry[1]); }).join('; ');
  // Reserve room for the landing path even when campaign values are long.
  var landingSummary = landingTags ? landingTags.slice(0, 500 - landingPath.length - 2) + '; ' + landingPath : landingPath;

  /* ---------- time-limited notice (also gated by Liquid on the server) ---------- */
  $$('[data-ends-on]').forEach(function (el) {
    var end = el.getAttribute('data-ends-on');
    var today = new Date(); var iso = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
    if (end && iso > end) el.hidden = true;
  });

  /* ---------- prototype steam drift (corporate-owned elements only) ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var steams = $$('[data-corporate] [data-parallax]');
    var ticking = false;
    var drift = function () {
      ticking = false;
      var vh = window.innerHeight;
      steams.forEach(function (s) {
        var r = s.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
        s.style.transform = 'translate3d(0,' + (p * -12).toFixed(2) + '%,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(drift); } }, { passive: true });
    drift();
  }

  /* ---------- sub navigation: keep the current item in view inside the sideways list (no page scroll) ---------- */
  var scroller = $('.corp-subnav__scroll');
  var cur = scroller && $('[aria-current]', scroller);
  if (scroller && cur && scroller.scrollWidth > scroller.clientWidth) {
    var sr = scroller.getBoundingClientRect(), cr = cur.getBoundingClientRect();
    var clear = sr.right - sr.width * 0.2; // the right fifth fades into paper (corporate.css)
    if (cr.left < sr.left) scroller.scrollLeft += cr.left - sr.left - 16;
    else if (cr.right > clear) scroller.scrollLeft += cr.right - clear + 8;
  }

  /* ---------- cases filter ---------- */
  var filterBtns = $$('[data-case-filter]');
  if (filterBtns.length) {
    var status = $('[data-case-status]');
    var applyFilter = function (type, push) {
      if (!/^(retail|gift|collab)$/.test(type)) type = 'all';
      filterBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-case-filter') === type ? 'true' : 'false'); });
      var n = 0;
      $$('[data-case-group]').forEach(function (g) { var show = type === 'all' || g.getAttribute('data-case-group') === type; g.hidden = !show; if (show) n += $$('[data-case]', g).length; });
      if (status) status.textContent = (status.getAttribute('data-count-template') || '__COUNT__件の事例を表示しています。').replace('__COUNT__', n);
      if (push) { var u = new URL(location.href); if (type === 'all') u.searchParams.delete('type'); else u.searchParams.set('type', type); history.replaceState(null, '', u); }
    };
    filterBtns.forEach(function (b) { b.addEventListener('click', function () { applyFilter(b.getAttribute('data-case-filter'), true); }); });
    applyFilter(new URLSearchParams(location.search).get('type') || 'all', false);
  }

  /* ---------- summary list (confirm / sent) ---------- */
  function summaryHtml(rows) {
    return rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
  }

  /* The receipt is readable only after Shopify reports a successful POST. */
  var success = $('[data-corp-success]');
  var sentList = success && $('[data-sent-list]', success);
  if (sentList) {
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_NAME) || 'null');
      var rowsStored = stored && (stored.rows || stored);
      if (rowsStored && rowsStored.length) { sentList.innerHTML = summaryHtml(rowsStored); var e = $('[data-sent-empty]'); if (e) e.hidden = true; }
      var m = $('[data-sent-material]'); if (m && stored && stored.type === 'material') m.hidden = false;
      sessionStorage.removeItem(STORAGE_NAME);
    } catch (err) { /* The server success message remains available without browser storage. */ }
    $$('[data-steps] li').forEach(function (li, i) { if (i === 2) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); });
    return;
  }
  /* ---------- inquiry form ---------- */
  var form = $('[data-corp-form]');
  if (!form) return;
  var messages = $('[data-corp-fields]', form);
  var requiredText = messages && messages.getAttribute('data-required-text') || '必須';
  var optionalText = messages && messages.getAttribute('data-optional-text') || '任意';
  var requiredMessage = messages && messages.getAttribute('data-required-message') || '入力してください。';
  var consentAgreed = messages && messages.getAttribute('data-consent-agreed') || '同意する';
  function fillAttribution() {
    var input = $('input[name="contact[ref]"]', form);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'contact[ref]';
      form.appendChild(input);
    }
    input.value = landingSummary;
    input.disabled = false;
  }
  // Also cover native submit() calls, which do not dispatch a submit event.
  fillAttribution();
  // Never reuse a stale receipt after a server rejection or a fresh form visit.
  try { sessionStorage.removeItem(STORAGE_NAME); } catch (err) { /* Optional receipt only. */ }
  // Without JavaScript a noscript button submits the native form directly.
  $$('[data-js-submit]', form).forEach(function (b) { b.hidden = false; b.disabled = false; });
  var typeRadios = $$('input[name="contact[ご相談の種類]"]', form);
  var errorsBox = $('[data-errors]', form);
  var hint = $('[data-type-hint]', form);
  var confirmBox = $('[data-confirm]');
  var sentBox = $('[data-sent]');
  var steps = $$('[data-steps] li');
  var lastRows = [];
  var sending = false;
  form.noValidate = true; // Conditional validation and linked errors own the enhanced path.

  function currentType() { var r = typeRadios.filter(function (x) { return x.checked; })[0]; return r ? r.value : ''; }
  function setDisabled(container, off) { $$('input, select, textarea', container).forEach(function (el) { el.disabled = off; }); }
  function labelOf(field) {
    var l = $('legend, label', field);
    var copy = l.cloneNode(true);
    $$('.corp-req, .corp-pending__tag', copy).forEach(function (x) { x.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }
  function requiredNow(field, type) {
    if (field.getAttribute('data-required') === '1') return true;
    var t = field.getAttribute('data-required-types');
    return !!(t && type && t.split(',').indexOf(type) >= 0);
  }
  function isShown(el) { return !el.closest('[hidden]'); }

  function refreshConditional() {
    var type = currentType();
    $$('[data-group]', form).forEach(function (g) {
      var on = g.getAttribute('data-group') === type;
      g.hidden = !on; setDisabled(g, !on);
    });
    if (hint) hint.hidden = !!type;
    $$('[data-types]', form).forEach(function (f) {
      var on = !!type && f.getAttribute('data-types').split(',').indexOf(type) >= 0;
      f.hidden = !on; setDisabled(f, !on);
    });
    $$('[data-show-if]', form).forEach(function (f) {
      var rule = f.getAttribute('data-show-if').split(':');
      var src = $('#' + rule[0], form);
      var on = !!src && isShown(src) && $$('input:checked', src).some(function (i) { return i.value === rule[1]; });
      f.hidden = !on; setDisabled(f, !on);
    });
    $$('[data-required-types]', form).forEach(function (f) {
      var tag = $('[data-req-tag]', f);
      if (!tag) return;
      var req = requiredNow(f, type);
      tag.textContent = req ? requiredText : optionalText;
      tag.classList.toggle('corp-req--must', req);
    });
    var companyHelp = $('[data-company-help]', form);
    if (companyHelp) companyHelp.parentElement.hidden = !(type === 'bridal' || type === 'other');
  }

  function clearErrors() {
    $$('.corp-error', form).forEach(function (e) { e.hidden = true; e.textContent = ''; });
    $$('[aria-invalid]', form).forEach(function (e) { e.removeAttribute('aria-invalid'); });
    $$('.is-invalid', form).forEach(function (e) { e.classList.remove('is-invalid'); });
    errorsBox.hidden = true;
  }
  function fieldError(field, msg) {
    var fold = field.closest('details');
    if (fold) fold.open = true; // an error inside 「詳しいご希望」 must be seen
    var err = $('.corp-error', field);
    err.textContent = msg; err.hidden = false;
    field.classList.add('is-invalid');
    $$('input, select, textarea', field).forEach(function (i) { if (i.type !== 'hidden') i.setAttribute('aria-invalid', 'true'); });
  }

  function validate() {
    clearErrors();
    var type = currentType();
    var problems = [];
    $$('[data-field]', form).forEach(function (f) {
      if (!isShown(f)) return;
      var inputs = $$('input, select, textarea', f).filter(function (i) { return !i.disabled; });
      if (!inputs.length) return;
      var kind = f.getAttribute('data-kind');
      var value;
      if (kind === 'radio' || kind === 'checkbox' || kind === 'consent') value = inputs.filter(function (i) { return i.checked; }).length ? 'x' : '';
      else value = inputs[0].value.trim();
      var msg = '';
      if (!value && requiredNow(f, type)) msg = f.getAttribute('data-err') || requiredMessage;
      else if (value && kind === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) msg = f.getAttribute('data-err-format');
      else if (value && kind === 'url' && !/^https:\/\/\S+\.\S+/.test(value)) msg = f.getAttribute('data-err-format');
      else if (value && kind === 'tel' && !/^[0-9０-９\-－‐ー+]{6,}$/.test(value)) msg = f.getAttribute('data-err-format');
      else if (kind === 'date' && inputs[0].validity && inputs[0].validity.badInput) msg = f.getAttribute('data-err-format');
      if (msg) { fieldError(f, msg); problems.push({ field: f, label: labelOf(f), msg: msg }); }
    });
    if (problems.length) {
      $('[data-error-count]', errorsBox).textContent = String(problems.length);
      $('[data-error-list]', errorsBox).innerHTML = problems.map(function (p) {
        var target = $('input, select, textarea', p.field);
        return '<li><a href="#' + esc(target.id) + '">' + esc(p.label) + '：' + esc(p.msg) + '</a></li>';
      }).join('');
      errorsBox.hidden = false;
      errorsBox.focus();
    }
    return !problems.length;
  }
  errorsBox.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (!a) return;
    e.preventDefault();
    var t = $(a.getAttribute('href'), form); if (t) { t.focus(); }
  });

  function collect() {
    var rows = [];
    $$('[data-field]', form).forEach(function (f) {
      if (!isShown(f)) return;
      var inputs = $$('input, select, textarea', f).filter(function (i) { return !i.disabled && i.type !== 'hidden' && i.name !== 'contact[ref]'; });
      if (!inputs.length) return;
      var kind = f.getAttribute('data-kind');
      var v;
      if (kind === 'radio' || kind === 'checkbox') v = inputs.filter(function (i) { return i.checked; }).map(function (i) { var s = i.nextElementSibling.cloneNode(true); $$('.corp-pending__tag', s).forEach(function (x) { x.remove(); }); return s.textContent.replace(/\s+/g, ' ').trim(); }).join('、');
      else if (kind === 'consent') v = inputs[0].checked ? consentAgreed : '';
      else if (inputs[0].tagName === 'SELECT') v = $$('option', inputs[0]).filter(function (o) { return o.selected && o.index > 0; }).map(function (o) { return o.textContent.trim(); }).join('、'); // the untouched first choice (選んでください／未定) is not an answer
      else v = inputs[0].value.trim();
      if (v) rows.push([labelOf(f), v]);
    });
    return rows;
  }

  function setStep(n) { steps.forEach(function (li, i) { if (i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); }); }
  function showView(view) {
    $$('[data-inquiry-input]').forEach(function (el) { el.hidden = view !== 'input'; });
    confirmBox.hidden = view !== 'confirm';
    sentBox.hidden = view !== 'sent';
    setStep({ input: 0, confirm: 1, sent: 2 }[view]);
    var stepsEl = $('[data-steps]');
    var top = (stepsEl ? stepsEl.getBoundingClientRect().top : 0) + window.scrollY - 140;
    window.scrollTo(0, Math.max(0, top));
  }

  typeRadios.forEach(function (r) { r.addEventListener('change', refreshConditional); });
  form.addEventListener('change', function (e) { if (e.target.closest('[data-field]')) refreshConditional(); });

  var from = $('[data-sent-from]', form);
  var params = new URLSearchParams(location.search);
  var preset = params.get('type');
  if (preset && TYPES.indexOf(preset) >= 0) { var r = typeRadios.filter(function (x) { return x.value === preset; })[0]; if (r) r.checked = true; }
  if (from) from.value = 'type=' + (preset || '') + (document.referrer ? ' / from=' + document.referrer : '');
  refreshConditional();

  function confirmInquiry() {
    if (sending) return;
    fillAttribution();
    if (!validate()) return;
    lastRows = collect();
    $('[data-confirm-list]').innerHTML = summaryHtml(lastRows);
    showView('confirm');
    $('[data-confirm-h]').focus({ preventScroll: true });
  }
  $$('[data-js-submit]', form).forEach(function (button) { button.addEventListener('click', confirmInquiry); });
  form.addEventListener('submit', function (e) {
    fillAttribution();
    if (sending) return;
    e.preventDefault();
    confirmInquiry();
  });
  $('[data-back]').addEventListener('click', function () { showView('input'); var first = $('input:not([type=hidden]), select, textarea', form); if (first) first.focus({ preventScroll: true }); });
  $('[data-send]').addEventListener('click', function () {
    if (sending) return;
    // Return to input for validation: hidden confirmation fields still belong to the native POST.
    showView('input');
    if (!validate()) return;
    lastRows = collect();
    var type = currentType();
    // Classification comes first in DOM/FormData order; reuse existing answers only.
    var summaryFields = {
      wholesale: ['', '卸開始時期'], gift: ['ギフト数量', 'ギフト時期'],
      oem: ['OEM数量', 'OEM時期'], bridal: ['ブライダル数量', '挙式日']
    };
    ['数量', '時期'].forEach(function (label, index) {
      var sourceLabel = (summaryFields[type] || [])[index];
      var control = sourceLabel && $('[name="contact[' + sourceLabel + ']"]', form);
      $('[data-email-summary="' + label + '"]', form).value = control && !control.disabled ? control.value.trim() : '';
      // Avoid a second copy of the same answer in the email.
      if (control && !control.disabled) control.disabled = true;
    });
    // Shopify receives one canonical contact[...] value per checkbox/radio group.
    $$('[data-field]', form).forEach(function (field) {
      var kind = field.getAttribute('data-kind');
      if (!isShown(field) || (kind !== 'checkbox' && kind !== 'radio')) return;
      var controls = $$('input', field).filter(function (input) { return !input.disabled; });
      var chosen = controls.filter(function (input) { return input.checked; });
      if (!chosen.length) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = controls[0].name;
      hidden.value = chosen.map(function (input) {
        if (hidden.name !== 'contact[ご相談の種類]') return input.value;
        return input.nextElementSibling.textContent.replace(/\s+/g, ' ').trim();
      }).join('、');
      controls[0].parentNode.insertBefore(hidden, controls[0]);
      controls.forEach(function (input) { input.disabled = true; });
    });
    try { sessionStorage.setItem(STORAGE_NAME, JSON.stringify({ rows: lastRows, type: type })); } catch (err) { /* Receipt summary is optional; sending does not depend on storage. */ }
    showView('confirm');
    sending = true;
    $('[data-send]').disabled = true;
    fillAttribution();
    // Both paths preserve Shopify's submit/captcha listeners; no Ajax or optimistic success.
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var submit = document.createElement('button');
      submit.type = 'submit'; submit.hidden = true;
      form.appendChild(submit);
      submit.click();
      submit.remove();
    }
  });
})();
